module.exports = __webpack_public_path__ + "static/ipad-61b95c756e1a25c71c5d60647ec5ecbb.png";